import { Factory } from '../Factory';
import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class CustodianService implements IService {
  private readonly ItemResource;

  constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
      const custodianResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/custodian/:id`,
        {'id': '@id', 'projectId': '@projectId'},
        {'update': {method: 'PUT'}});

    this.ItemResource = resourceWrapperService.WrapActions(custodianResource);
  }

  public async FindAll(projectId: string) {
    return this.ItemResource.query({
      projectId: projectId,
    }).$promise;
  }

  public Create(projectId, name) {
    return new this.ItemResource({
      projectId: projectId,
      name: name
    });
  };

  public Save(newCustodian, callback, errorCallback) {
    return newCustodian.$save(custodian => callback?.call(this, custodian), response => errorCallback?.call(this, response.data));
  };
}

frontendApp.factory("CustodianService", ["$resource", "ConfigService", "ResourceWrapperService", Factory.Create(CustodianService)]);
